import { render, staticRenderFns } from "./KlarnaFormHeader.vue?vue&type=template&id=4b3d5b88&scoped=true&"
import script from "./KlarnaFormHeader.vue?vue&type=script&lang=js&"
export * from "./KlarnaFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d5b88",
  null
  
)

export default component.exports